exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#timelineContainer {\n  position: relative;\n  background-color: white;\n  z-index: 1000;\n\n  border-right: solid 2px;\n  border-bottom: solid 2px;\n\n  /* ユーザーによるドラッグ選択を拒否（ドラッグ機能に対する保護） */\n  user-select: none; /* CSS3 */\n  -moz-user-select: none; /* Firefox */\n  -webkit-user-select: none; /* Safari、Chromeなど */\n  -ms-user-select: none; /* IE10かららしい */\n}\n.tlTicksCells {\n  box-sizing: border-box;\n  opacity: 0.5;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3640345c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/SpTimelineContainer.vue
// module id = 492
// module chunks = 0